// Attachment registry — populated by registerAttachments() before
// rendering any markdown that contains [[kind:id]] tokens. Single
// source of truth for the {id → metadata} lookup that the markdown-it
// parser rule uses to expand a bare ID reference into a full attachment
// card (filename, mime, size, URL).
//
// Lives at module scope (not Vuex, not a component, not bundled into
// markdown.js) because the markdown-it parser rule is registered once
// at module load and runs synchronously inside markdownToHTML(); it
// has no Vue context and can't dispatch through a store. Vuex would
// add reactivity machinery the registry doesn't need (nothing watches
// it; it's render-time-only) and force every consumer to roundtrip
// through a mutation for the same write-then-read flow we have today.
// The synchronous register → render pair inside one Vue computed
// evaluation guarantees no cross-component race. If markdown rendering
// ever becomes async, switch to a parser-context-passed model — until
// then, a module-scoped Map is the minimum viable design.

export const ATTACHMENT_REGISTRY = new Map();

// Single canonical shape — matches backend AttachmentViewModel
// (camelCase). Both the editor's upload util and the comment/thread
// hydration path store records here in this exact shape, so the
// [[kind:id]] renderer has only one set of keys to read.
export function registerAttachments(attachments) {
  if (!Array.isArray(attachments)) return;
  for (const attachment of attachments) {
    if (!attachment || attachment.id == null) continue;
    ATTACHMENT_REGISTRY.set(String(attachment.id), {
      id: attachment.id,
      fileURL: attachment.fileURL,
      fileName: attachment.fileName,
      mimeType: attachment.mimeType,
      fileSizeBytes: attachment.fileSizeBytes,
    });
  }
}

export function resolveAttachment(attachmentId) {
  return ATTACHMENT_REGISTRY.get(String(attachmentId)) || null;
}
